/**
 * HPH Collection Filters
 * Handles filter dropdowns, checkbox auto-submit, sort auto-submit,
 * and price input cleanup. No inline event handlers.
 * Vanilla JS, IIFE pattern. Zero dependencies.
 *
 * Created: June 8, 2026
 */

(function() {
  'use strict';

  var form = document.getElementById('hph-filter-form');
  if (!form) return;

  /* The collection page opts into AJAX (hph-collection-ajax.js owns filtering, sort, the
     mobile drawer and dropdowns there). Bail out so we never double-bind or trigger a full
     GET reload. The search page has no [data-hph-ajax], so it keeps this native behaviour. */
  if (form.hasAttribute('data-hph-ajax')) return;

  /* --- Mobile: toggle filter list visibility --- */
  var toggleBtn = document.querySelector('[data-hph-filters-toggle]');
  var filterList = document.querySelector('[data-hph-filters-list]');
  if (toggleBtn && filterList) {
    toggleBtn.addEventListener('click', function() {
      var isOpen = filterList.classList.toggle('hph-filters__list--open');
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* --- Mobile: off-canvas sidebar drawer (categories + filters) --- */
  var sidebar = document.querySelector('[data-hph-collection-sidebar]');
  var sToggle = document.querySelector('[data-hph-sidebar-toggle]');
  var sClose = document.querySelector('[data-hph-sidebar-close]');
  var sBackdrop = document.querySelector('[data-hph-sidebar-backdrop]');
  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('hph-collection__sidebar--open');
    if (sBackdrop) sBackdrop.hidden = false;
    document.body.style.overflow = 'hidden';
    if (sToggle) sToggle.setAttribute('aria-expanded', 'true');
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('hph-collection__sidebar--open');
    if (sBackdrop) sBackdrop.hidden = true;
    document.body.style.overflow = '';
    if (sToggle) sToggle.setAttribute('aria-expanded', 'false');
  }
  if (sToggle) sToggle.addEventListener('click', openSidebar);
  if (sClose) sClose.addEventListener('click', closeSidebar);
  if (sBackdrop) sBackdrop.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSidebar();
  });

  /* --- Close dropdowns when clicking outside --- */
  document.addEventListener('click', function(e) {
    var dropdowns = document.querySelectorAll('[data-hph-filter-dropdown]');
    for (var i = 0; i < dropdowns.length; i++) {
      if (!dropdowns[i].contains(e.target)) {
        dropdowns[i].removeAttribute('open');
      }
    }
  });

  /* --- Close dropdowns on Escape key --- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var dropdowns = document.querySelectorAll('[data-hph-filter-dropdown][open]');
      for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].removeAttribute('open');
      }
    }
  });

  /* --- Filter checkbox: auto-submit on change --- */
  var checkboxes = form.querySelectorAll('[data-hph-filter-checkbox]');
  for (var i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener('change', function() {
      stripEmptyPrices();
      form.submit();
    });
  }

  /* --- Sort dropdown: auto-submit on change --- */
  var sortSelect = form.querySelector('[data-hph-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      stripEmptyPrices();
      form.submit();
    });
  }

  /* --- Strip empty price inputs before any submit --- */
  form.addEventListener('submit', function() {
    stripEmptyPrices();
  });

  function stripEmptyPrices() {
    var priceInputs = form.querySelectorAll('.hph-filter-price__input');
    for (var j = 0; j < priceInputs.length; j++) {
      if (priceInputs[j].value === '') {
        priceInputs[j].removeAttribute('name');
      }
    }
  }

})();
